import Vue from 'vue'
import App from './App.vue'

new Vue({
  el: 'body',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js